export default {
  from: 'Da',
  to: 'A',
  enterNameOrNumber: 'Immetti il numero o il nome...',
  typeMessage: 'Digita il messaggio...',
  send: 'Invia',
};
